import React from "react";

const UnsavedChangesModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="overlay">
      <section className="outline" onClick={() => props.Close()}></section>
      <section className="modal-body">
        <div className="modal-head">
          <p>{translateText("unsaved_changes")}</p>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </div>
        <p className="modal-info">
          {translateText("unsaved_changes_modal_text")}
        </p>
        <section className="modal-actions">
          <span className="secondary-action" onClick={() => props.Close()}>
            {translateText("cancel")}
          </span>
          <span className="main-action" onClick={() => props.AcceptLeave()}>
            {translateText("discard_and_leave")}
          </span>
        </section>
      </section>
    </div>
  );
};

export default UnsavedChangesModal;
